import React, { useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function QRScanner({ open, onClose, onResult }) {
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    let active = true;
    const containerId = "qr-reader";

    (async () => {
      try {
        const { Html5Qrcode } = await import("html5-qrcode");
        if (!active) return;
        const scanner = new Html5Qrcode(containerId);
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 240, height: 240 } },
          (decodedText) => {
            onResult(decodedText);
          },
          () => {}
        );
      } catch (e) {
        // camera unavailable or permission denied
      }
    })();

    return () => {
      active = false;
      const s = scannerRef.current;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open, onResult]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Scan asset QR</DialogTitle>
          <DialogDescription>Point your camera at an asset tag to open it.</DialogDescription>
        </DialogHeader>
        <div id="qr-reader" className="overflow-hidden rounded-xl border border-border" style={{ width: "100%" }} />
        <p className="text-center text-xs text-muted-foreground">Allow camera access if prompted.</p>
      </DialogContent>
    </Dialog>
  );
}
